import { stringifyQs } from "@dashboard/utils/urls";

export const bannersSection = "/banners/";

export const bannerListPath = bannersSection;
export const bannerListUrl = (params?: { audience?: string }) =>
  bannerListPath + (params ? "?" + stringifyQs(params) : "");

export const bannerAddPath = bannersSection + "add";
export const bannerAddUrl = bannerAddPath;

export const bannerDetailPath = (id: string) => bannersSection + id;
export const bannerDetailUrl = (id: string) =>
  bannerDetailPath(encodeURIComponent(id));
